module.exports = __webpack_public_path__ + "img/CONTRATO DE GUATEMALA-2.84f42f5e.jpg";